// Wraps the search input in header.liquid. sections/predictive-search.liquid
// is never rendered into a template directly; it only exists so Shopify's
// Predictive Search API can render it on demand by section id, keyed off
// whatever the customer has typed.
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.closest('dialog');
    this.input = this.querySelector('input[type="search"]');
    this.resultsContainer = this.querySelector('#predictive-search');

    this.input.addEventListener(
      'input',
      this.debounce((event) => this.onChange(event), 300).bind(this)
    );

    document.querySelectorAll('[data-search-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        this.dialog.showModal();
        this.input.focus();
      });
    });

    this.querySelectorAll('[data-search-close]').forEach((button) => {
      button.addEventListener('click', () => this.dialog.close());
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.resultsContainer.innerHTML = '';
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(`${root}search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        // Unlike the cart's `sections` (plural) param, which returns clean
        // JSON-keyed HTML fragments, /search/suggest with a single
        // `section_id` still wraps the markup in Shopify's usual
        // #shopify-section-<id> div, so we have to unwrap it ourselves.
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        this.resultsContainer.innerHTML = section ? section.innerHTML : text;
      })
      .catch(() => {
        this.resultsContainer.innerHTML = '';
      });
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
